<template>
  <button
    class="border-primary btn text-primary rounded add-to-list--btn-mobile"
    @click="open"
    :aria-label="$t('addItemToList')"
    ref="addToListModalBtnMobileRef"
  >
    <span></span>
    <span v-if="showText">{{ $t('addToList') }}</span
    ><font-awesome-icon class="" icon="list-check" @click="open" />
  </button>
</template>

<script>
import ModalService from '@/modules/modals/services/modal.service';

import WCAddToListModal from '../WCAddToListModal/WCAddToListModal.vue';

export default {
  props: {
    item: {
      type: Object,
    },
    showText: {
      type: Boolean,
      default: false,
    },
    isGuest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async open() {
      if (!this.isGuest) {
        try {
          await ModalService.open(WCAddToListModal, { item: this.item });
        } catch (error) {
          // NOOP
        } finally {
          if (this.$refs.addToListModalBtnMobileRef) this.$refs.addToListModalBtnMobileRef.focus();
        }
      } else {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-to-list--btn-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
